module.exports = __webpack_public_path__ + "img/banner2025_m.a26abb97.jpg";